module.exports = __webpack_public_path__ + "media/images/banner/olimpia_virtus-7cfff28adab11266783edb63aa506a5c.jpg";